/**
 * StandOut WordPress Theme
 * Theme-wide functionality initialization
 *
 * @package StandOut
 * @since 2.0.0
 */
import { onDomReady } from "@utils/dom-ready";
onDomReady(() => {
    // Breadcrumbs (conditional loading)
    const breadcrumbs = document.querySelector(".breadcrumbs");
    if (breadcrumbs) {
        import("./breadcrumbs")
            .then(({ initBreadcrumbs }) => {
            initBreadcrumbs();
        })
            .catch((error) => {
            console.error("Failed to load breadcrumbs module:", error);
        });
    }
    // Navigation (conditional loading)
    const navigation = document.querySelector(".main-navigation");
    const scrollProgress = document.querySelector(".scroll-progress-container");
    if (navigation) {
        import("./navigation")
            .then(({ ThemeNavigation }) => {
            new ThemeNavigation();
        })
            .catch((error) => {
            console.error("Failed to load navigation module:", error);
        });
        // Fade in navigation and scroll progress (CSS transition handles the 2s duration)
        navigation.style.opacity = "1";
        if (scrollProgress) {
            scrollProgress.style.opacity = "1";
        }
    }
});
